import {ReactNode} from "react";
import {Navigate, useLocation, useParams} from "react-router-dom";
import {useAuth} from "../context/AuthProvider";

interface ProtectedRouteProps {
    children: ReactNode;
}

export function ProtectedRoute({children}: ProtectedRouteProps) {
    const {isAuthenticated, vendorId: authVendorId} = useAuth();
    const {vendorId: urlVendorId} = useParams<{vendorId?: string}>();
    const location = useLocation();

    if (!isAuthenticated) {
        return <Navigate to="/login" state={{from: location}} replace />;
    }
    //test
    // Prevent accessing another vendor's pages via URL manipulation
    if (urlVendorId && authVendorId && urlVendorId !== authVendorId) {
        return <Navigate to={`/dashboard/${authVendorId}`} replace />;
    }

    return <>{children}</>;
}
